const transformations = [
  {
    id: 1,
    label: 'Roof Cleaning',
    location: 'Boca Raton, FL',
    beforeSrc: 'https://public.readdy.ai/ai/img_res/7607a70ab6025b71db4f546b6aaabbf6.jpg',
    afterSrc: 'https://readdy.ai/api/search-image?query=clean%20bright%20sparkling%20terracotta%20clay%20tile%20roof%20Florida%20home%20after%20professional%20soft%20wash%20cleaning%20gleaming%20restored%20pristine%20like%20new%20sunshine&width=700&height=500&seq=after-roof-1&orientation=landscape',
    caption: 'Roof went from black to brand new — same day service',
  },
  {
    id: 2,
    label: 'Driveway Cleaning',
    location: 'Delray Beach, FL',
    beforeSrc: 'https://readdy.ai/api/search-image?query=dirty%20stained%20dark%20concrete%20driveway%20oil%20stains%20mold%20mildew%20buildup%20discolored%20Florida%20suburban%20home%20before%20pressure%20washing%20heavily%20soiled&width=700&height=500&seq=before-drive-1&orientation=landscape',
    afterSrc: 'https://readdy.ai/api/search-image?query=spotless%20bright%20white%20clean%20concrete%20driveway%20Florida%20home%20after%20professional%20pressure%20washing%20restored%20brilliant%20curb%20appeal%20sunshine%20new&width=700&height=500&seq=after-drive-1&orientation=landscape',
    caption: 'Years of oil stains gone — looks freshly poured',
  },
  {
    id: 3,
    label: 'Screen Patio',
    location: 'Coral Springs, FL',
    beforeSrc: 'https://readdy.ai/api/search-image?query=dirty%20grimy%20screen%20patio%20pool%20cage%20enclosure%20Florida%20home%20algae%20dirt%20buildup%20oxidized%20frames%20before%20cleaning%20green%20mold%20stained%20neglected&width=700&height=500&seq=before-patio-1&orientation=landscape',
    afterSrc: 'https://readdy.ai/api/search-image?query=clean%20sparkling%20pool%20screen%20enclosure%20patio%20Florida%20home%20after%20professional%20pressure%20washing%20crystal%20clear%20pristine%20white%20frames%20backyard&width=700&height=500&seq=after-patio-1&orientation=landscape',
    caption: 'HOA-ready after one visit — screens crystal clear',
  },
];

export default function BeforeAfterSection() {
  return (
    <section id="results" className="bg-slate-50 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 lg:mb-16">
          <span className="inline-block bg-teal-100 text-teal-700 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Real Results
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 mb-4">
            See The Transformation
          </h2>
          <p className="text-slate-500 text-lg max-w-xl mx-auto">
            This is what your property could look like. Every job we do in South Florida.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {transformations.map((item) => (
            <article key={item.id} className="rounded-2xl overflow-hidden border border-gray-200 bg-white">
              {/* Images side by side */}
              <div className="relative grid grid-cols-2 h-56 sm:h-64">
                {/* Before */}
                <div className="relative overflow-hidden">
                  <img
                    src={item.beforeSrc}
                    alt={`Before ${item.label} - South Florida`}
                    title={`Before ${item.label} pressure cleaning`}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-3 left-3 bg-red-600 text-white text-xs font-black px-2.5 py-1 rounded-md uppercase tracking-wide">
                    Before
                  </div>
                </div>
                {/* After */}
                <div className="relative overflow-hidden">
                  <img
                    src={item.afterSrc}
                    alt={`After ${item.label} - South Florida`}
                    title={`After professional ${item.label} cleaning`}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-3 right-3 bg-teal-600 text-white text-xs font-black px-2.5 py-1 rounded-md uppercase tracking-wide">
                    After
                  </div>
                </div>
                {/* Divider line */}
                <div className="absolute inset-y-0 left-1/2 -translate-x-1/2 w-1 bg-white z-10"></div>
                <div className="absolute inset-y-0 left-1/2 -translate-x-1/2 z-20 flex items-center">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white border-2 border-gray-300">
                    <i className="ri-arrow-left-right-line text-slate-600 text-sm"></i>
                  </div>
                </div>
              </div>

              {/* Info */}
              <div className="p-5">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-teal-700 font-bold text-sm">{item.label}</span>
                  <span className="flex items-center gap-1 text-slate-400 text-xs">
                    <i className="ri-map-pin-line text-xs"></i>
                    {item.location}
                  </span>
                </div>
                <p className="text-slate-600 text-sm leading-snug">{item.caption}</p>
              </div>
            </article>
          ))}
        </div>

        {/* CTA under gallery */}
        <div className="text-center mt-10">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-bold px-7 py-3.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-sparkling-2-line text-base"></i>
            </div>
            Make My Property Look Like This
          </a>
        </div>
      </div>
    </section>
  );
}
